export const UNAUTH_USER_ID = 'unauth';

export const TOOLBAR_MIN_HEIGHT = 37;

export const SIDE_NAVBAR_WIDE_WIDTH = 317;

export const SIGNATURE_SIDEBAR_WIDE_WIDTH = 200;

export const RIGHT_SIDEBAR_WIDTH = 404;

export const AppAPIName = 'AppAPI';

export const UsersAPIName = 'UsersAPI';

export const MessagesAPIName = 'MessagesAPI';

export const UnAuthAPIName = 'UnAuthAPI';

export * from './paymentsConsts';
export * from './clientConsts';
export * from './pathConsts';
export * from './flagConsts';
export * from './dataTypes';
export * from './componentTypes';
export * from './filesConsts';
export * from './fileConsts';
export * from './fieldsTypes';
export * from './permissionConsts';
export * from './entityConsts';
export * from './dateConsts';
export * from './landingConsts';
export * from './userConsts';
export * from './validationConsts';
export * from './notificationsConsts';
export * from './tasksConsts';
export * from './errorConsts';
export * from './intakeFormsConsts';
export * from './onboardingConsts';
export * from './stringConsts';
export * from './domainConsts';
export * from './referralConsts';
export * from './tableColumnConsts';
export * from './moduleManagementConsts';
export * from './signatureConsts';
export * from './fontsConsts';
